import {default as personal} from '../views/pages/personal/personal.html';
import {default as business} from '../views/pages/business/business.html';


export var routes = {
    list: [
        {name: 'personal', url: '/personal', template: personal, controller: 'personalController as vm'},
        {name: 'business', url: '/business', template: business, controller: 'businessController as vmbusiness'}
    ]
};



//////////////////
// WEBPACK FOOTER
// ./app/routing.js
// module id = 226
// module chunks = 0